(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-multipacks"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.multipacksUiBound) return;
    window.multipacksUiBound = true;

    function formatMoney(cents, format) {
      const placeholder = /\{\{\s*(\w+)\s*\}\}/;
      const match = (format || '').match(placeholder);
      if (!match || Number.isNaN(cents)) return '';

      const formatWithDelimiters = (number, precision, thousands, decimal) => {
        const amount = (number / 100).toFixed(precision);
        const parts = amount.split('.');
        const dollars = parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, `$1${thousands}`);
        const fraction = precision > 0 ? `${decimal}${parts[1]}` : '';
        return dollars + fraction;
      };

      let value = '';
      switch (match[1]) {
        case 'amount':
          value = formatWithDelimiters(cents, 2, ',', '.');
          break;
        case 'amount_no_decimals':
          value = formatWithDelimiters(cents, 0, ',', '.');
          break;
        case 'amount_with_comma_separator':
          value = formatWithDelimiters(cents, 2, '.', ',');
          break;
        case 'amount_no_decimals_with_comma_separator':
          value = formatWithDelimiters(cents, 0, '.', ',');
          break;
        case 'amount_with_apostrophe_separator':
          value = formatWithDelimiters(cents, 2, "'", '.');
          break;
        case 'amount_no_decimals_with_space_separator':
          value = formatWithDelimiters(cents, 0, ' ', '');
          break;
        case 'amount_with_space_separator':
          value = formatWithDelimiters(cents, 2, ' ', ',');
          break;
        case 'amount_with_period_and_space_separator':
          value = formatWithDelimiters(cents, 2, ' ', '.');
          break;
        default:
          return '';
      }

      return format.replace(placeholder, value);
    }

    function productInfoFrom(node) {
      return node.closest('product-info') || document;
    }

    function quantityBox(info) {
      return info.querySelector('.product-form__cart--box > .product-form__quantity');
    }

    function quantityField(info) {
      return info.querySelector('.quantity__input');
    }

    function packForQuantity(info, quantity) {
      const quantityNumber = parseInt(quantity, 10);
      return [...info.querySelectorAll('.product-multipacks__input')].find(
        (pack) => parseInt(pack.dataset.quantity, 10) === quantityNumber
      );
    }

    function setTotal(info, quantity) {
      const total = info.querySelector('[data-multipacks-total]');
      const root = info.querySelector('.product-multipacks');
      if (!total || !root) return;

      const quantityNumber = parseInt(quantity, 10);
      const unitPrice = parseInt(root.dataset.unitPrice, 10);
      const regularCents = unitPrice * quantityNumber;
      const pack = packForQuantity(info, quantityNumber);
      let saleCents = regularCents;

      if (pack?.dataset.totalCents) {
        saleCents = parseInt(pack.dataset.totalCents, 10);
      } else if (quantityNumber > 3) {
        const bulk = packForQuantity(info, 3);
        const bulkQuantity = parseInt(bulk?.dataset.quantity, 10);
        const bulkTotal = parseInt(bulk?.dataset.totalCents, 10);
        if (bulkQuantity > 0 && bulkTotal > 0) {
          saleCents = Math.round((bulkTotal * quantityNumber) / bulkQuantity);
        }
      }

      const savingsCents = Math.max(regularCents - saleCents, 0);
      const packTotal = pack?.closest('.product-multipacks__option')?.querySelector('.product-multipacks__total');
      const saleText = packTotal ? packTotal.textContent.trim() : formatMoney(saleCents, root.dataset.moneyFormat);

      if (saleText) total.textContent = saleText;

      const custom = info.querySelector('.product-multipacks__purchase')?.classList.contains('is-custom-quantity');
      const showBreakdown = custom && savingsCents > 0;
      const compare = info.querySelector('[data-multipacks-compare]');
      const save = info.querySelector('[data-multipacks-save]');

      if (compare) {
        compare.hidden = !showBreakdown;
        compare.textContent = showBreakdown ? formatMoney(regularCents, root.dataset.moneyFormat) : '';
      }

      if (save) {
        save.hidden = !showBreakdown;
        const template = save.dataset.labelTemplate || '';
        save.textContent = showBreakdown ? template.replace('__AMOUNT__', formatMoney(savingsCents, root.dataset.moneyFormat)) : '';
      }
    }

    function setQuantity(info, quantity) {
      const input = quantityField(info);
      if (!input || input.value === String(quantity)) return;
      input.value = quantity;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }

    function selectedPackQuantity(info) {
      const checked = info.querySelector('.product-multipacks__input:checked');
      if (checked) return checked.dataset.quantity;
      return info.dataset.multipackQuantity || '';
    }

    function rememberQuantity(info, quantity) {
      if (quantity) info.dataset.multipackQuantity = quantity;
    }

    function restoreSelectedQuantity(info) {
      if (!info.querySelector('.product-multipacks')) return;
      const quantity = selectedPackQuantity(info);
      if (!quantity) return;
      setQuantity(info, quantity);
      setTotal(info, quantity);
    }

    function placeStepper(info, custom) {
      const stepper = info.querySelector('quantity-input.quantity');
      const home = quantityBox(info);
      const slot = info.querySelector('[data-multipacks-quantity-slot]');
      const purchase = info.querySelector('.product-multipacks__purchase');
      if (!stepper || !home || !slot || !purchase) return;

      const token = String(Date.now());
      slot.dataset.motion = token;
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      if (custom) {
        slot.appendChild(stepper);
        purchase.classList.add('is-custom-quantity');
        if (reduceMotion) {
          slot.classList.add('is-open');
          return;
        }
        requestAnimationFrame(() => {
          if (slot.dataset.motion !== token) return;
          slot.classList.add('is-open');
        });
        return;
      }

      slot.classList.remove('is-open');
      purchase.classList.remove('is-custom-quantity');
      const finish = () => {
        if (slot.dataset.motion !== token) return;
        slot.dataset.motion = '';
        if (stepper.parentElement === slot) home.appendChild(stepper);
        purchase.classList.remove('is-custom-quantity');
      };
      if (reduceMotion) {
        finish();
        return;
      }
      window.setTimeout(finish, 280);
    }

    function applyPack(info, pack) {
      placeStepper(info, false);
      rememberQuantity(info, pack.dataset.quantity);
      info.querySelector('[data-multipacks-more]')?.setAttribute('aria-expanded', 'false');
      setQuantity(info, pack.dataset.quantity);
      pack.checked = true;
      setTotal(info, pack.dataset.quantity);
    }

    function openCustomQuantity(info, more) {
      const presets = [...info.querySelectorAll('.product-multipacks__input')].map((pack) => parseInt(pack.dataset.quantity, 10));
      let quantity = parseInt(selectedPackQuantity(info) || quantityField(info)?.value || '1', 10);
      const maxPreset = Math.max(...presets, 0);
      if (presets.includes(quantity)) quantity = maxPreset + 1;

      info.querySelectorAll('.product-multipacks__input').forEach((pack) => {
        pack.checked = false;
      });
      rememberQuantity(info, quantity);
      placeStepper(info, true);
      more.setAttribute('aria-expanded', 'true');
      setQuantity(info, quantity);
      setTotal(info, quantity);
      quantityField(info)?.focus();
    }

    document.addEventListener('change', (event) => {
      const pack = event.target.closest('.product-multipacks__input');
      if (pack) {
        applyPack(productInfoFrom(pack), pack);
        return;
      }

      if (!event.target.classList.contains('quantity__input')) return;
      const info = productInfoFrom(event.target);
      if (!info.querySelector('.product-multipacks')) return;

      const quantityNumber = parseInt(event.target.value, 10);
      const custom = info.querySelector('.product-multipacks__purchase')?.classList.contains('is-custom-quantity');
      info.querySelectorAll('.product-multipacks__input').forEach((input) => {
        input.checked = !custom && parseInt(input.dataset.quantity, 10) === quantityNumber;
      });
      rememberQuantity(info, quantityNumber);
      setTotal(info, quantityNumber);
    });

    document.addEventListener('click', (event) => {
      const more = event.target.closest('[data-multipacks-more]');
      if (!more) return;
      const info = productInfoFrom(more);
      if (!quantityBox(info)) return;

      if (info.querySelector('.product-multipacks__purchase')?.classList.contains('is-custom-quantity')) {
        const pack = packForQuantity(info, 3);
        if (pack) {
          pack.checked = true;
          applyPack(info, pack);
        }
        return;
      }

      openCustomQuantity(info, more);
    });

    document.addEventListener('product-info:updated', (event) => {
      const info = event.target;
      if (!info.querySelector('.product-multipacks')) return;
      const checked = info.querySelector('.product-multipacks__input:checked');
      placeStepper(info, false);
      info.querySelector('[data-multipacks-more]')?.setAttribute('aria-expanded', 'false');
      if (!checked) return;
      rememberQuantity(info, checked.dataset.quantity);
      setQuantity(info, checked.dataset.quantity);
      setTotal(info, checked.dataset.quantity);
    });

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.quantityUpdate, () => {
        document.querySelectorAll('product-info').forEach((info) => {
          restoreSelectedQuantity(info);
        });
      });
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
